export default __webpack_public_path__ + "static/media/cvv-card.010000c0.webp";